export default [
  {
    path: '/h5/fans-rank-list',
    component: () => import('./Page.vue'),
    meta: {
      title: '粉丝团排行榜',
    },
  },
]
